import Configs from "../Configs";


export const createCompanyColorCssVariable = (companyColor) => {
    document.body.style.setProperty('--company-color', companyColor || Configs.companyColor); // avoid re-rendering
};